import Icon from 'components/_UI/Icon';
import LinkPage from 'components/_UI/LinkPage';
import Text from 'components/_UI/Text';
import CONTACT from 'constants/contact';
import SOCIAL_MEDIA from 'constants/socialMedia';
import React from 'react'
import paths from 'routes/paths';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

export default function Footer() {
    return (
        <Column>
            <ContainerFooter>
                <ColumnToRow fullyCentralized>

                    <LinksContainer>
                        <CenterToLeft>
                            <Text type='bold' color={colors.nightDark}>Geral</Text>
                            <LinkButton href={CONTACT.whatsapp} target='_blank'>
                                <Text >Central de ajuda</Text>
                            </LinkButton>
                            <LinkButton href={'https://docs.google.com/forms/d/192P_cUM7SJVSpGkod0FFf5lqkSgbmi5TQrA15djApiw/'} target='_blank'>
                                <Text >Quero criar eventos no Whizr</Text>
                            </LinkButton>
                        </CenterToLeft>

                        <CenterToLeft>
                            <Text type='bold' color={colors.nightDark} marginTop={'25px'}>Termos</Text>
                            <LinkButton>
                                <LinkPage to={paths.terms.useTerms}>
                                    <Text paddingBottom={0}>Termos de uso</Text>
                                </LinkPage>
                            </LinkButton>

                            <LinkButton>
                                <LinkPage to={paths.terms.policiePrivacy}>
                                    <Text paddingBottom={0}>Termos de privacidade</Text>
                                </LinkPage>
                            </LinkButton>
                        </CenterToLeft>
                    </LinksContainer>

                    <WhizrLogoContainer width='33.3%' fullyCentralized>
                        <Column width='200px' height='auto'>
                            <Icon name='whizr-inline-logo-dark' />
                        </Column>
                    </WhizrLogoContainer>

                    <SocialContainer>
                        <Column fullyCentralized width='auto'>
                            <Text type='bold' color={colors.nightDark}>Redes sociais</Text>
                            <Row fullyCentralized>
                                <LinkButton social href={SOCIAL_MEDIA.instagram} target='_blank'>
                                    <Icon name='instagram' color={colors.night} />
                                </LinkButton>

                                <LinkButton social href={SOCIAL_MEDIA.facebook} target='_blank'>
                                    <Icon name='facebook' color={colors.night} />
                                </LinkButton>

                                <LinkButton social href={SOCIAL_MEDIA.linkedin} target='_blank'>
                                    <Icon name='linkedin' color={colors.night} />
                                </LinkButton>
                            </Row>
                        </Column>

                        <Column fullyCentralized width='100px' marginTop='25px'>
                            <Text type='bold' color={colors.nightDark} paddingBottom={0}>Acelerado por</Text>
                            <LinkButton href='https://www.inovativa.online/' target='_blank'>
                                <InovativaSeal src='/assets/images/inovativa-seal.png' />
                            </LinkButton>
                        </Column>
                    </SocialContainer >

                </ColumnToRow>

            </ContainerFooter >

            <CopyRightContainer>
                <Text name='small' paddingBottom={0} textAlign={'center'}>
                    © {new Date().getFullYear()} Whizr Plataforma de Conteudo LTDA. Todos direitos reservados.
                </Text>
            </CopyRightContainer>
        </Column >
    )
}

const ContainerFooter = styled(Column)`
    width: 100%;
    padding: 40px;
    background-color: #f5f5f7;
    border-top: 1px solid ${colors.neutralDark};

    @media screen  and (min-width: ${breakpoints.lg}) {
        padding: 40px 8%;
    }
    
    @media screen  and (min-width: ${breakpoints.xl}) {
        padding: 40px 6%;
    }
`;

const FlexColumn = styled(Column)`
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
    }
`;

const CopyRightContainer = styled(FullyCentered)`
    background-color: #ebebf1;
    padding: 20px;
    padding-bottom: 80px;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        padding: 20px;
    }
`;

const InovativaSeal = styled.img`
    width: 80px;
    height: auto;
`;

const LinkButton = styled.a`
    cursor: pointer;
    transition: all ease-in-out .25s;
    
    ${({ social }) => social && `
        width: 30px;
        height: 30px;
    `};

    &:hover { 
        transform: scale(1.05);
    }
`;

const ColumnToRow = styled(Column)`
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row !important;
    }
`;

const RowToColumn = styled(Row)`
    width: 100%;
    justify-content: space-between;

    
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: column !important;
        
        div:nth-child(2) {
            margin-top: 30px;
        }
    }
`;

const CenterToLeft = styled(Column)`
    text-align: center;

    @media screen and (min-width: ${breakpoints.lg}) {
        text-align: left;
    }
`;

const WhizrLogoContainer = styled(Column)`
    display: none;
    @media screen and (min-width: ${breakpoints.lg})  {
        display: flex;
    }
`;

const LinksContainer = styled(Column)`
    width: 100%;
    
    @media screen and (min-width: ${breakpoints.lg})  {
        width: 33.3%;
    }
`;

const SocialContainer = styled(FullyCentered)`
    flex-direction: column;
    width: 100%;
    margin-top: 25px;

    @media screen and (min-width: ${breakpoints.lg})  {
        width: 33.3%;
        align-items: flex-end !important;

        & > div {
            align-items: center;
            justify-content: center;
            width: 130px;
        }
    }
`;